// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qzBRY","info":"Card_info__KLz7e","title":"Card_title__PRsQu","descrip":"Card_descrip__7-I1y","button":"Card_button__EEns5","price":"Card_price__KSogv"};